import React, { Component } from 'react';
import withStyles from 'react-jss'
import {withContext} from '../main/custom/StateProvider';
import Drawer from '@material-ui/core/Drawer';

const styles = theme => ({
    overlay:{
        position:'absolute',
        top:0,
        left:0,
        right:0,
        bottom:0,
        backgroundColor:'rgba(0,0,0,0.6)',
        zIndex:1000,
    },
    drawer:{
        position:'absolute',
        border:'1px solid black',
        borderRadius:10,
        padding:10,
        backgroundColor: 'white',
        zIndex:1001,
        top:'50%',
        left:'50%'
    },
    closeButton:{
        float:'right',
        zIndex:1010,
    }
});

class contentDrawer extends Component {
    state={
        wallet:[]
    };

    onClose = () => {
        this.props.context.update({
            drawerContent: false,
            drawerWidth:300,
            drawerHeight:300
        })
    }



    render() {
        const {context} = this.props;
//content={this.props.context.drawerContent} width={this.props.context.drawerWidth} height={this.props.context.drawerHeight}
        return (

        <Drawer anchor="right" open={context.drawerContent} onClose={this.onClose}>

            <div
              tabIndex={0}
              role="button"
              style={{width:context.drawerWidth || '300px', padding:0}}
            >
                {context.drawerContent}
            </div>
        </Drawer>
        )
    }
}

export default withContext(withStyles(styles,{withTheme:true})(contentDrawer));